import React from "react";

export default function DreamDrawImg({ children, text }) {
  return (
    <div className='dream-draw__media'>
      <div className='dream-draw-img'>
        {children}
        <p className='dream-draw-img__text'>
          {text ??
            "Two Dream Homes for the price of one with every ticket bought before August 31."}
        </p>
      </div>
    </div>
  );
}
